var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDragMenuBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 15,
    viewBox: "0 0 21 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.01824 13.8654H6.77733V1.1346H2.01824C1.92377 1.1346 1.84616 1.16345 1.78542 1.22115C1.72469 1.27885 1.69432 1.35258 1.69432 1.44233V13.5577C1.69432 13.6474 1.72469 13.7211 1.78542 13.7788C1.84616 13.8365 1.92377 13.8654 2.01824 13.8654ZM7.97165 13.8654H13.0283V1.1346H7.97165V13.8654ZM14.2227 13.8654H18.9818C19.0762 13.8654 19.1538 13.8365 19.2146 13.7788C19.2753 13.7211 19.3057 13.6474 19.3057 13.5577V1.44233C19.3057 1.35258 19.2753 1.27885 19.2146 1.22115C19.1538 1.16345 19.0762 1.1346 18.9818 1.1346H14.2227V13.8654ZM2.01824 15C1.60545 15 1.24921 14.8576 0.949528 14.5729C0.649843 14.2882 0.5 13.9498 0.5 13.5577V1.44233C0.5 1.05018 0.649843 0.711752 0.949528 0.427051C1.24921 0.14235 1.60545 0 2.01824 0H18.9818C19.3946 0 19.7508 0.14235 20.0505 0.427051C20.3502 0.711752 20.5 1.05018 20.5 1.44233V13.5577C20.5 13.9498 20.3502 14.2882 20.0505 14.5729C19.7508 14.8576 19.3946 15 18.9818 15H2.01824Z",
    fill: "#5B73E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragMenuBtn);
export default __webpack_public_path__ + "static/media/drag-menu-btn.de73ca88a19ceb8c51dff89bfff5bbe1.svg";
export { ForwardRef as ReactComponent };